import { render, staticRenderFns } from "./GetOrderByMsg.vue?vue&type=template&id=5c0d353e&scoped=true"
import script from "./GetOrderByMsg.vue?vue&type=script&lang=js"
export * from "./GetOrderByMsg.vue?vue&type=script&lang=js"
import style0 from "./GetOrderByMsg.vue?vue&type=style&index=0&id=5c0d353e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d353e",
  null
  
)

export default component.exports